<template>
  <div ref="containerRef" class="timeline-container">
    <div class="hospedaje-wrapper animate-item">
      <h2 class="recomendacion-hospedaje">Hospedaje</h2>
      <p class="hospedaje-descripcion">
        Hemos preparado una selección de opciones recomendadas para tu estadía durante nuestro evento.
      </p>

      <button @click="openModal" class="pdf-button">
        Ver Opciones de Hospedaje <i class="fas fa-file-image" />
      </button>
    </div>

    <Transition name="fade">
      <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <button class="close-button" @click="closeModal" aria-label="Cerrar">×</button>
          
          <div class="modal-scroll-container">
            <img 
              :src="imagenHospedaje" 
              class="hospedaje-img-render" 
              alt="Opciones de Hospedaje"
            />
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';

// Importación limpia desde tu carpeta assets
import imgHospedaje from '@/assets/p.jpg';

export default {
  name: 'HospedajeVue',
  setup() {
    const containerRef = ref(null);
    const isModalOpen = ref(false);
    const imagenHospedaje = ref(imgHospedaje);

    const openModal = () => {
      isModalOpen.value = true;
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      isModalOpen.value = false;
      document.body.style.overflow = '';
    };

    onMounted(() => {
      nextTick(() => {
        const elementoAnimado = containerRef.value.querySelector('.animate-item');

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              gsap.fromTo(
                entry.target,
                { opacity: 0, y: 40, scale: 0.98 },
                {
                  opacity: 1,
                  y: 0,
                  scale: 1,
                  duration: 0.8,
                  ease: 'power2.out',
                }
              );
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2 });

        if (elementoAnimado) observer.observe(elementoAnimado);
      });
    });

    return {
      containerRef,
      isModalOpen,
      imagenHospedaje,
      openModal,
      closeModal
    };
  }
};
</script>

<style scoped>
.timeline-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 40px 20px;
}

.hospedaje-wrapper {
  width: 100%;
  max-width: 500px;
  text-align: center;
  padding: 60px 25px;
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
  background-color: #78866b;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.recomendacion-hospedaje {
  font-family: 'corinthia', serif;
  font-size: 56px;
  margin-bottom: 15px;
  color: #ebf0e9d7;
}

.hospedaje-descripcion {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: rgba(238, 243, 236, 0.85);
  margin-bottom: 30px;
}

.pdf-button {
  display: inline-block;
  text-decoration: none;
  background: #ffffff;
  color: #333333;
  padding: 12px 24px;
  font-family: 'padres', sans-serif;
  font-weight: bold;
  border: none;
  border-radius: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.3s ease;
  font-size: 14px;
  cursor: pointer;
}

.pdf-button:hover {
  background: #f5f2f2;
  transform: scale(1.03);
}

/* ==========================================================================
   MODAL AJUSTADO AL CONTORNO DE LA IMAGEN (SIN FRANJAS NEGRAS)
   ========================================================================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75); 
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
  padding: 24px;
  box-sizing: border-box;
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: 420px;
  /* Clave: toma la altura del contenido exacto de la imagen sin inflarse */
  height: max-content; 
  max-height: 85vh; 
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(55, 67, 54, 0.9); 
  color: #fff;
  border: none;
  width: 36px;
  height: 36px;
  font-size: 24px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10002;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

.modal-scroll-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; 
  padding: 0;
  margin: 0;
}

.hospedaje-img-render {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  pointer-events: auto; /* Habilita interacción táctil total */
}

/* Transición Fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Estado inicial GSAP */
.animate-item {
  opacity: 0;
  transform: translateY(40px);
  will-change: transform, opacity;
}
</style>